import React, { FC, ReactNode } from 'react';

import BadgeButton, { BadgeButtonProps } from '../BadgeButton';

import { ReactComponent as NotificationsIcon } from '../../../icons/notifications.svg';
import { ReactComponent as NotificationsClippedIcon } from '../../../icons/notificationsClipped.svg';
import { IconButtonProps } from '../IconButton';

export interface NotificationButtonProps extends Omit<IconButtonProps, 'label'>, BadgeButtonProps {
  /** Content of the badge. */
  children?: ReactNode;
  label?: string;
}

const NotificationButton: FC<NotificationButtonProps> = (props) => (
  <BadgeButton
    Icon={NotificationsIcon}
    ClippedIcon={NotificationsClippedIcon}
    data-testid="NotificationButton"
    {...props}
  />
);

export default NotificationButton;
